<template>
  <div id="listPage" @touchmove="articleListTouchMove">
    <div id="ArticleList">
      <div id="ArticleListScroller" :style='ArticleListScrollerStyle'>
        <div id="TopLogoContainer">
          <img src="..\assets\top_logo.png">
        </div>
        <div id="ClassLabel">
          <div class="ClassLabel" :style="ClassLabelStyle"
               v-for="(c,key) in allClasses"
               :class="{selectClass:thisClass==key}"
               @click="viewClass(key)">{{c}}</div>
          <div id="ClassLineContainer">
            <div id="ClassLine"
                 :style="ClassLineStyle">
            </div>
          </div>
        </div>
        <div id="ListContainer" :style="ListContainerStyle">
          <transition :enter-active-class="'slideIn'+listInDirecter"
                      :leave-active-class="'slideOut'+listOutDirecter">
            <component class="animated"
            style="position:absolute;left:0px;top:0px;animation-duration: 0.3s;-webkit-animation-duration: 0.3s;" :is="classPage"></component>
          </transition>
        </div>
      </div>
    </div>
    <div style="position: absolute;left:0px;top:0px;width: 100%;height: 100%;background:rgba(0,0,0,0.5);" v-if="PreviewOrAboutUsIsOpen"></div>
    <div id="articleListfloorBT">
      <img class="aboutUsIMG" src="../assets/about_us_bt.png" @click="viewAboutUs()">
    </div>
    <div id="previewBT">
      <img class="previewBTIMG" src="../assets/preview_bt.png" @click="openclose()">
    </div>
    <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
      <AboutUs  class="aboutUsPage" v-if="aboutUsIsOpen"/>
    </transition>
    <transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
      <preview class="previewBTPage" v-if="previewIsOpen" />
    </transition>
  </div>
</template>
<script>
  import class1 from "./class1";
  import class2 from "./class2";
  import preview from "./preview";
  import AboutUs from './AboutUs';

  import pageStackStore from "../store/pageStackStore"
  import articlesStore_2 from "../store/articlesStore_2";
  import store from '../store/'

  export default {
    name: "ArticleList",
    components:{
      preview,
      AboutUs
    },
    data(){
      return {
        allClasses:articlesStore_2.state.classes,
        // lastClass:class1,
        listInDirecter:'Left',
        listOutDirecter:'Right',
        windowScroller:0
      }
    },
    created() {
      if(!this.$route.params.class){
        this.$route.params.class=1;
      }
    },
    mounted(){
      var scrollerConfig = {
        '//Description' : 'Default scroller with no configuration',
        touchSpeed:1
      };
      this.windowScroller = new Scroller('#ArticleList', scrollerConfig);
      this.setShare();
    },
    methods:{
      viewClass(key) {
        if(this.thisClass<key){
          this.listInDirecter='Right';
          this.listOutDirecter='Left';
        }else{
          this.listInDirecter='Left';
          this.listOutDirecter='Right';
        }
        pageStackStore.commit('pushPageStack', this.$route.path)
        this.$router.replace('/ArticleList/'+(key+1));
      },
      articleListTouchMove(e){
        e.preventDefault();
      },
      openclose(){
        pageStackStore.commit("OpenClose")
      },
      viewAboutUs:function (key) {
        pageStackStore.commit('OpenCloseAboutUs')
      },
      count(isshare,id,issue){
        let params = new URLSearchParams();
        params.append('id', id);
        params.append('issue', issue);
        params.append('isshare', isshare);
        let chanel=getQueryVariable('chanel');
        if(!chanel) chanel=100;
        params.append('chanel', chanel);
        let isview=this.$cookies.get('isview_'+id+"_"+issue);
        if(isview) {
          params.append('isview', 1);
        }else{
          params.append('isview', 0);
          this.$cookies.set('isview_'+id+"_"+issue,1,'1d')
        }

        this.axios.post('count.php',params)
          .then((response)=>{
            // console.log(response.data)
          })
          .catch((error)=>{
            console.log(error);
          });
      },
      setShare(){
        let shareData = {
          title:this.$store.state.ShareInfo.title,
          desc: this.$store.state.ShareInfo.desc,
          link: this.$store.state.ShareInfo.link,
          imgUrl: require('../assets/'+this.$store.state.ShareInfo.icon),
          success:function(){
            this.count(1,this.$store.state.ShareInfo.count,this.$store.state.ShareInfo.issue);
          }.bind(this)
        };
        wx.onMenuShareAppMessage(shareData);
        wx.onMenuShareTimeline(shareData);
      }
    },
    computed:{
      ClassLineStyle() {
        return {
          marginLeft:11.25/this.allClasses.length*this.thisClass+(11.25/this.allClasses.length-1.8)/2+'rem',
        }
      },
      ClassLabelStyle(){
        return {
          width:11.25/this.allClasses.length+"rem"
        }
      },
      thisClass(){
        return this.$route.params.class-1;
      },
      classPage() {
        switch (parseInt(this.$route.params.class)) {
          case 1:
            return class1;
          case 2:
            return class2;
          default:
            return class1;
        }
      },
      ListContainerStyle(){
        return{
          height:(store.state.WindowSize.WindowHeightRem-1.11)+'rem'
        }
      },
      ArticleListScrollerStyle(){
        return{
          height:(store.state.WindowSize.WindowHeightRem+1.99)+'rem'
        }
      },
      previewIsOpen(){
        return pageStackStore.state.preveiwOpen
      },
      aboutUsIsOpen(){
        return pageStackStore.state.aboutUsOpen
      },
      PreviewOrAboutUsIsOpen(){
        return pageStackStore.state.preveiwOpen||pageStackStore.state.aboutUsOpen
      }
    }
  }
</script>

<style lang="less" scoped>
@fullWidth:11.25rem;
.fullWidhth{
  width: @fullWidth;
}

#listPage{
  .fullWidhth();

  height: 100%;
  //border-top:.02rem solid #000000;
}
#ArticleList{
  .fullWidhth();

  height: 100%;

  #ArticleListScroller{
    .fullWidhth();

    #TopLogoContainer{
      .fullWidhth();

      height: 1.99rem;
      position: absolute;
      left: 0px;
      top:0px;
      z-index: 21;

      img{
        .fullWidhth();
      }
    }

    #ClassLabel{
      .fullWidhth();

      height: 1.11rem;
      background: #ffffff;
      color: white;
      font-weight: bolder;
      box-shadow: 0px 0px .15rem .01rem #cccccc;
      /*box-shadow: 0px 0px .15rem .01rem #000000;*/
      //box-shadow: 0px 0rem .15rem .05rem rgba(100,100,100,.5);
      position: absolute;
      left:0px;
      top: 1.95rem;
      z-index: 11;

      .ClassLabel{
        text-align: center;

        height:.85rem;
        line-height:.85rem;
        font-size:.45rem;
        color: #cacaca;
        margin-top: 0.08rem;
      }
      .selectClass {
        color: #1a8bff;
      }
      #ClassLineContainer{
        .fullWidhth();

        height: .06rem;
        #ClassLine{
          background: #1a8bff;
          transition-duration: 0.5s;
          width: 1.8rem;
          height: .06rem;
        }
      }
    }

    #ListContainer{
      .fullWidhth();

      overflow: hidden;
      background: #f1f1f1;
      position: absolute;
      left:0px;
      top:3.1rem;
    }
  }
}

@animateTime:.7s;
#articleListfloorBT {
  position: absolute;
  width:2.14rem;
  height: .91rem;
  left:8.66rem;
  bottom:1.15rem;

  .aboutUsIMG{
    width: 100%;
  }
}
.aboutUsPage{
  animation-duration: @animateTime;
  -webkit-animation-duration: @animateTime;
}
.previewBTPage{
  animation-duration: @animateTime;
  -webkit-animation-duration: @animateTime;
}
#previewBT {
  position: absolute;
  overflow: hidden;
  width:2.14rem;
  height: .91rem;
  left:6.26rem;
  bottom:1.15rem;

  .previewBTIMG{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleList.vue